<template>
  <div>
    <popper
      ref="popperPopover"
      trigger="click"
      :preventDefault="true"
      :stopPropagation="true"
      :append-to-body="appendToBody"
      :options="{
        placement: placement,
        positionFixed: optionPositionFixed,
        modifiers: { offset: { enabled: true, offset: optionOffset }, preventOverflow: { enabled: optionPreventOverflow, priority: optionPreventOverflowPriority } }
      }">
      <div :class="['popper', 'popper-popover', sizeClass]">
        <div class="popper-popover-header no-gutters" v-if="showHeader">
          <div class="col-sm-2"> </div>
          <span class="col-sm-8 text-center">{{headerTitle}}</span>
          <div class="col-sm-2 text-right">
            <button class="btn btn-sm popper-popover-header-button float-right" @click.prevent="hidePopover">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div ref="popoverContentContainer" :class="['popper-popover-content', {'popover-content-scrollable': scrollable}]" :style="contentStyles">
          <slot />
        </div>
      </div>
      <span slot="reference"></span>
    </popper>
    
  </div>
</template>

<style lang="scss">
.popper {
  color: inherit;
}
.popper-popover {
  padding: 0px;
  border-radius: $layout-minor-border-radius;
}
.popper-popover.popover-medium {
  padding: 0px 0px 1rem 0px;
  min-width: 325px;
  width: 325px;
}
.popper-popover.popover-large {
  padding: 0px 0px 1rem 0px;
  min-width: 430px;
  width: 430px;
}
.popper-popover.popover-xlarge {
  padding: 0px 0px 1rem 0px;
  min-width: 500px;
  width: 500px;
}
.popper-popover.popover-xxlarge {
  padding: 0px 0px 1rem 0px;
  min-width: 800px;
  width: 800px;
}
.popper-popover.popover-w50 {
  padding: 0px 0px 1rem 0px;
  min-width: 50vw;
  width: 50vw;
}
.popper-popover.popover-w60 {
  padding: 0px 0px 1rem 0px;
  min-width: 60vw;
  width: 60vw;
}
.popper-popover.popover-w75 {
  padding: 0px 0px 1rem 0px;
  min-width: 75vw;
  width: 75vw;
}
.popper-popover.popover-no-padding {
  padding: 0 !important;
}
.popper-popover-header {
  min-height: 30px;
  border-bottom: 1px solid #e7eaec;
  line-height: 30px;
  vertical-align: middle;
  font-size: 15px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.popper-popover-header-button {
  font-size: 1.0rem;
  font-weight: 600;
  line-height: 1.1rem;
  vertical-align: middle;
  color: #a0a0a0;
  background-color: transparent;
  
}
.popper-popover-content {
  padding: 0px;
  text-align: left;
}
.popper-popover-content .form-group {
  margin-bottom: 0.10rem;
}
.popover-content-scrollable {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  props: {
    showHeader: {
      type: Boolean,
      default: false
    },
    headerTitle: String,
    placement: {
      type: String,
      default: 'bottom'
    },
    offset: {
      type: String,
      default: '0, 10'
    },
    optionPreventOverflow: {
      type: Boolean,
      default: true
    },
    optionPreventOverflowPriority: {
      type: Array,
      default: () => { return ['left', 'right', 'top', 'bottom'] }
    },
    // Option - Position Fixed
    // Set to true for issues (like production station) where the popper overflows due to issues with flex containers
    optionPositionFixed: {
      type: Boolean,
      default: false
    },
    sizeClass: String,
    scrollable: {
      type: Boolean,
      default: false
    },
    scrollHeight: {
      type: [String, Number],
      default: '40vh'
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'popper': Popper
  },
  data() {
    return {
      optionOffset: this.$props.offset,
      positionX: 0,
      positionY: 0
    }    
  },
  computed: {
    contentStyles() {
      var styles = {}
      if(this.scrollable)
        styles.height = this.scrollHeight
      return styles
    }
  },
  methods: {
    displayFromElement(el) {
      this.$refs.popperPopover.referenceElm = el
      this.$refs.popperPopover.showPopper = true

      if(this.scrollable) {
        this.$nextTick(() => {
          if(this.$refs.popoverContentContainer)
            this.$refs.popoverContentContainer.scrollTo(0, 0)
        })
      }

      this.$refs.popperPopover.updatePopper()
    },
    displayFromPosition(posX, posY, width = null, height = null) {
      this.positionX = posX
      this.positionY = posY
      let clientWidth = width || 1
      let clientHeight = height || 1


      let popoverComponent = this
      this.displayFromElement({
        clientWidth: clientWidth,
        clientHeight: clientHeight,
        getBoundingClientRect: function() {
          return new DOMRect(popoverComponent.positionX, popoverComponent.positionY, clientWidth, clientHeight)
        },
        removeEventListener: function() {
        }
      })
    },

    hidePopover() {
      this.$nextTick(() => {
        this.$refs.popperPopover.doClose()
      })
    },
    updatePopper() {
      this.$refs.popperPopover.updatePopper()
    }
  }
}
</script>